export default {
	apiDomain:process.env.VUE_APP_API_DOMAIN,
	action:{
		getEditorialDetail:"/getEditorialDetail",
	}
}